<template>
    <v-stepper :steps="step" class="hidden-xs-only">

        <v-stepper-header v-if="getUsedShortcut">
            <v-stepper-step :complete="steps > 0" step="" @click.native="goToStart"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="steps > 1" step="" @click.native="goToGeneral"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 2" step="" class="shortcut-used"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 3" step="" class="shortcut-used"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 4" step="" class="shortcut-used"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 5" step="" class="shortcut-used"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 6" step=""></v-stepper-step>

        </v-stepper-header>


        <v-stepper-header v-else>
            <v-stepper-step :complete="steps > 0" step="" @click.native="goToStart"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="steps > 1" step="" @click.native="goToGeneral"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 2" step="" @click.native="goToMainSymptom"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 3" step="" @click.native="goToRelatedSymptom"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 4" step="" @click.native="goToSymptomQuestions"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 5" step="" @click.native="goToSharedQuestions"></v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="steps > 6" step=""></v-stepper-step>

        </v-stepper-header>

    </v-stepper>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "StandardStepper",
        data(){
            return{
                 step: ''
            }
        },
        computed: mapGetters({
            getUsedShortcut: 'PfEvaluationStore/getUsedShortcut'
        }),
        methods:{
          goToStart(){
              this.$router.push('/pathfinder/start-questions');
          },
          goToGeneral(){
              this.$router.push('/pathfinder/general-questions');
          },
          goToMainSymptom() {
              this.$router.push('/pathfinder/main-symptom');
          },
          goToRelatedSymptom() {
            this.$router.push('/pathfinder/related-symptoms');
          },
          goToSymptomQuestions() {
            this.$router.push('/pathfinder/symptom-questions');
          },
          goToSharedQuestions() {
            this.$router.push('/pathfinder/shared-questions');
          }
        },
        props: ['steps'],
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/shared/StandardStepper.vue